exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:768px){.news-newscardsslider-component>*{padding-right:0!important;padding-left:0!important}}.news-newscardsslider-component .well{height:420px}@media (max-width:768px){.news-newscardsslider-component .well{padding-right:0!important;padding-left:0!important}}.news-newscardsslider-component__title-wrap{padding:0 16px 48px}.news-newscardsslider-component__slider{margin-top:-48px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/news/newscardsslider.scss
// module id = 1023
// module chunks = 0